module.exports = __webpack_public_path__ + "static/img/f452dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/button.png
// module id = 626
// module chunks = 2